import React from 'react';
import InputFields from './components/InputFields/InputFields';
import classNames from 'classnames';
import style from './EditForm.module.scss';

interface IEditForm {
	isVisible: boolean;
}

const EditForm: React.FC<IEditForm> = ({ isVisible }) => {
	const containerClasses = classNames(style.container, { [style.visible]: isVisible });

	return (
		<div className={containerClasses} data-test="EditForm">
			<InputFields />
		</div>
	);
};

export default EditForm;
